import Vue from 'vue';
export const Loader = new Vue();


// WEBPACK FOOTER //
// ./src/bus/loader.js